/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';

import { ChooserChoice } from '../../../TaskInputs/types';
import { useRootSelector } from '../../../../../hooks/useRootSelector';
import { mediaBreakpoints } from '../../../../../common/responsive';
import { ActionButton } from '@components/ActionButton/ActionButton';

const styles = StyleSheet.create({
  button: {
    [mediaBreakpoints.mobile]: {
      height: 34,
      width: 80,
    },
  },
});

export namespace ChoiceButton {
  export interface Props {
    choice: ChooserChoice;
    handleChoiceClick: () => void;
    buttonStyle: 'primary' | 'secondary';
  }
}

export const ChoiceButton: React.FC<ChoiceButton.Props> = ({ choice, handleChoiceClick, buttonStyle }) => {
  const { value, isDisabled } = choice;
  const { isMobileView } = useRootSelector(state => state.layout);
  /**
   * NOTE: This text is hardcoded for now, because I wanted to avoid adding another property
   * to the TaskTemplate InputSchema unless absolutely necessary. This will need to be a passed
   * as a prop instead if we need to re-use the Chooser with different button text.
   */
  const buttonText = 'Validate';
  return (
    <ActionButton
      data-dd-privacy="allow"
      aria-label={buttonText}
      data-it={`ChoiceButton-${value}`}
      onClick={handleChoiceClick}
      option={buttonStyle}
      sizing={isMobileView ? 'xs' : 'sm'}
      type={'button'}
      disabled={isDisabled}
      customStyle={styles.button}
      color={colors.catalyst}
    >
      {buttonText}
    </ActionButton>
  );
};
